<template>
  <!-- 第二步：准备具备大小的dom容器 -->
  <div id="main1"></div>
</template>

<script>
// 第一步：下载并引入echarts
import * as echarts from 'echarts';

export default {
  mounted() {
    // 第三步：基于准备好的dom，初始化echarts实例 echarts.init(dom容器)
    var myChart1 = echarts.init(document.getElementById('main1'));
    // 第四步：指定配置项option
let option1 = {
  grid: {
  top: "25%",  // 图表距组件上边距离
 
},

  xAxis: {
     boundaryGap:false,
    type: 'category',
    data: ['1', '2', '3', '4', '5', '6', '7']
  },
  yAxis: {
    name: "单位:度",
          nameTextStyle: {
            color: "#aaa",
            nameLocation: "start",
          },
   axisLine: {                                    //坐标轴轴线设置
          show: true,                                  //是否显示坐标轴轴线
                                  //箭头大小        ([宽度,高度])
          symbolOffset: [0, 7],                      //箭头偏移
          lineStyle: {                                //坐标轴的线
            /* color: 'White',   */                          //线的颜色
            width: 3,                                //线的粗细程度    (用数字表示)
            type: 'solid',                            //线的类型        (可选solid  dotted  dashed)
            opacity:1                                //线的透明度        (用0~1的小数表示)
          }
        },
splitLine: {
              // 网格线
              show: true,
              lineStyle: { //分割线
              color: "#268C8C",
              width: 1,
              type: "dashed" //dotted：虚线 solid:实线
             }
            },


        
     min:0, //y轴的最小值
    max:400, //y轴最大值 
    interval:100, //值之间的间隔
    type: 'value',
  
  },
  series: [
    {
      smooth: true,
      showSymbol: false, // 只有在 tooltip hover 的时候显示symbol
      lineStyle: { // 线条样式
        normal: {
          width: 1,
      
              color: 'rgb(0, 200, 200, 80)'
   
        }
      },
      areaStyle: { // 区域面积
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgb(0, 50, 100)' // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: 'rgb(0, 50, 100, 50)' // 50% 处的颜色
            },
            {
              offset: 1,
              color: 'rgb(0, 50, 100, 0)' // 100% 处的颜色
            }
          ]
        }
      },
      data: [150, 230, 224, 218, 135, 147, 260],
      type: 'line'
    }
  ]
};

  
    // 第五步：绘制图表，把配置项给实例对象
    myChart1.setOption(option1);
  }
}
</script>

<style>
/* 第二步 */
#main1 {
  width: 500px;
  height: 300px;
  margin: auto; 
 
}

</style>
